/**
 * Centralized paths for map pin/marker images served from `/Content/Map`.
 * Use these constants instead of hard-coding the image paths.
 */
export const MapPins = {
	flag: "/Content/Map/map-flag-black.png",
	pin: "/Content/Map/map-pin-black.png",
	pinBlue: "/Content/Map/map-pin-blue.png",
	pinRed: "/Content/Map/map-pin-red.png",
	pinGreen: "/Content/Map/map-pin-green.png",
	gPin: "/Content/Map/map-gpin.png",
	person: "/Content/Map/map-person.png",
	office: "/Content/Map/pin-office.png",
	store: "/Content/Map/pin-store.png",
} as const;
